import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UserPreference } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { SearchUserPreferencesParams } from '../api';
import { createUserPreferenceApi, userPreferenceKeys } from '../api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useUserPreferences(params: SearchUserPreferencesParams): UseQueryResult<UserPreference[]> {
  const client = useApiClient('admin-auth');
  const api = createUserPreferenceApi(client);

  return useQuery({
    queryFn: (): Promise<UserPreference[]> => api.searchUserPreferences(params),
    queryKey: userPreferenceKeys.list(params),
  });
}
